<template>
    <div class="question-options">
        <button v-for="option in options" :key="option"
            class="option" :class="{selected : client.additional_info[property] == option}"
            @click.prevent="setSelectedOption(option)"
        >
            <span class="option--icon" :class="option"></span>
            <label class="option--label">{{$t('appointment_edit.label_'+option)}}</label>
        </button>
    </div>
</template>

<script>
export default {
    name:"ClientSingleSelect",

    props: {
        client : {type : Object},
        property : {type: String},
        options: {type: Array}
    },

    methods: {
        setSelectedOption(option) {
            this.$emit("onChange", option);

            const client = this.client;
            client.additional_info[this.property] = option;
            this.$emit("update:client", client);

            this.$forceUpdate();
        }
    }
};
</script>
